var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { NextChapter, PreviousChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { ShowColumn } from '../../state/view.actions';
import { filter, takeUntil } from 'rxjs/operators';
var ViewChaptersDrawerComponent = /** @class */ (function () {
    function ViewChaptersDrawerComponent(store) {
        this.store = store;
        this.chapterIndex = 0;
        this.ngUnsubscribe = new Subject();
    }
    ViewChaptersDrawerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedChapter$
            .pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapter) {
            _this.updateChapterIndex(chapter);
        });
    };
    ViewChaptersDrawerComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewChaptersDrawerComponent.prototype.handleChapterClick = function () {
        this.store.dispatch(new ShowColumn(true));
    };
    ViewChaptersDrawerComponent.prototype.handlePreviousClick = function () {
        this.store.dispatch(new PreviousChapter());
    };
    ViewChaptersDrawerComponent.prototype.handleNextClick = function () {
        this.store.dispatch(new NextChapter());
    };
    ViewChaptersDrawerComponent.prototype.updateChapterIndex = function (chapter) {
        var chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
        this.chapterIndex = chapters.findIndex(function (_chapter) { return _chapter.id === chapter.id; });
    };
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], ViewChaptersDrawerComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ViewChaptersDrawerComponent.prototype, "storyChapters$", void 0);
    return ViewChaptersDrawerComponent;
}());
export { ViewChaptersDrawerComponent };
